import type { FacetViewProps } from '@elastic/react-search-ui-views'
import { appendClassName } from 'utils'
import { useEffect, useState } from 'react'
import { Checkbox, FilterWrapper } from 'components/common/elastic/style'

const ReverseBooleanFacet = ({
	className,
	label,
	options,
	onRemove,
	onSelect,
	values,
}: FacetViewProps) => {
	/* Denne er bakvendt, til fordel for "vis inaktive koder".
			Fordi, inaktive koder har en false verdi, og aktive koder har en true verdi.
			For å vise inaktive koder, må vi derfor velge false.
			Som går i mot de andre, der man må velge true verdien.
	*/
	const trueOptions = options.find((option) => option.value === 'false')
	// The checkbox is selected when both 'true' and 'false' are in values
	const isSelected = values.includes('false')

	const [isDisabled, setIsDisabled] = useState<boolean>(false)

	const handleToggle = () => {
		if (isSelected) {
			// When unchecking, remove 'false' to show only 'true' values
			onRemove('false')
		} else {
			// When checking, show both "true" and "false" values
			onSelect(['false', 'true'])
		}
	}

	useEffect(() => {
		if (!trueOptions) {
			setIsDisabled(true)
		} else {
			setIsDisabled(false)
		}
	}, [trueOptions, isDisabled])

	useEffect(() => {
		// Set initial filter to only show "true" values (deselected state)
		// Only initialize if we have no values set yet
		if (values.length === 0) {
			//console.log('Initializing with true only')
			onSelect(['true'])
		}
	}, [values.length])

	return (
		<FilterWrapper className={appendClassName(className)}>
			<Checkbox
				type='checkbox'
				label={label}
				id={`facet-${label}`}
				name={`facet-${label}`}
				disabled={isDisabled}
				checked={isSelected}
				onChange={handleToggle}
				style={{ fontWeight: isSelected ? 'bold' : 'normal' }}
			/>
		</FilterWrapper>
	)
}

export default ReverseBooleanFacet
